/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebownphoto3Inputs */

const en_placewebownphoto3 = /** @type {(inputs: Placewebownphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload your own picture`)
};

const de_placewebownphoto3 = /** @type {(inputs: Placewebownphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenes Bild hochladen`)
};

/**
* | output |
* | --- |
* | "Upload your own picture" |
*
* @param {Placewebownphoto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebownphoto3 = /** @type {((inputs?: Placewebownphoto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebownphoto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebownphoto3(inputs)
	return de_placewebownphoto3(inputs)
});
export { placewebownphoto3 as "placeWebOwnPhoto" }